import createFetchClient from 'openapi-fetch'

import type { paths } from '../gen/tintin-user-service-schema'
import config from './req.pub.config'

export type { paths as PublicUserPaths }

export const publicUserReq = createFetchClient<paths>({
  ...config,
})
